import React from 'react';
import { motion } from 'framer-motion';
// Corrected import casing
import WhatsAppConnect from '../components/whatsappConnect';

const PageNavbar = () => (
  <nav className="fixed top-0 w-full bg-white shadow-md z-50 flex items-center justify-between px-6 h-24 overflow-hidden">
    <img src="/Hydrocawach_logo.png" alt="HydroCawach Logo" className="h-36 w-auto object-contain" />
    <h1 className="absolute left-1/2 transform -translate-x-1/2 text-blue-600 text-lg md:text-2xl font-bold text-center">
      Emulsion Stability Using Cavitation
    </h1>
  </nav>
);

// --- NEW DATA ARRAY FOR YOUR KEY BENEFITS ---
const keyBenefits = [
  {
    title: 'Efficient Size Reduction',
    description: 'Breaks down elastic materials like rubber and solid particles, increasing surface area and reactivity.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5M15 15l5.25 5.25" />
      </svg>
    )
  },
  {
    title: 'Uniform Emulsions',
    description: 'Produces fine, consistent droplets with narrow particle size distribution for high stability.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.374c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126z" />
      </svg>
    )
  },
  {
    title: 'Faster Reactions',
    description: 'Improved dispersion and contact between reactants accelerate chemical processes.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.125 1.125 0 010 2.25H5.625a1.125 1.125 0 010-2.25z" />
      </svg>
    )
  },
  {
    title: 'Handles Viscous Slurries',
    description: 'Easily processes concentrated, high-viscosity mixtures, reducing overall treatment volume.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.182 15.182a4.5 4.5 0 01-6.364 0M15.182 9.182a4.5 4.5 0 010 6.364M15.182 9.182L9.182 15.182m6-6l-6 6" />
      </svg>
    )
  },
  {
    title: 'Energy Efficient',
    description: 'More efficient than mechanical or ultrasonic mixing systems.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-6.364-.386l1.591-1.591M3 12H5.25m.386-6.364l1.591 1.591M12 6a3 3 0 100 6 3 3 0 000-6z" />
      </svg>
    )
  },
  {
    title: 'Stable Suspensions',
    description: 'Prevents settling and agglomeration, ensuring long-term uniformity.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6c-.621 0-1.125-.504-1.125-1.125v-3.75zM14.25 7.125c0-.621.504-1.125 1.125-1.125h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6c-.621 0-1.125-.504-1.125-1.125v-3.75zM2.25 15.125c0-.621.504-1.125 1.125-1.125h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6c-.621 0-1.125-.504-1.125-1.125v-3.75zM14.25 15.125c0-.621.504-1.125 1.125-1.125h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6c-.621 0-1.125-.504-1.125-1.125v-3.75z" />
      </svg>
    )
  }
];

const EmulsionStability = () => (
  <div className="bg-white text-gray-800 min-h-screen relative overflow-x-hidden">
    <PageNavbar />

    <div className="pt-32 px-4"> {/* Increased top padding */}
      <div className="p-8 max-w-6xl mx-auto">

        {/* Introduction Paragraph */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-lg text-center text-gray-700 max-w-4xl mx-auto mb-16"
        >
          Cavitation is an energy-efficient and chemical-free technology
          that enhances emulsion stability, particle dispersion, and reaction efficiency.
          The rapid formation and collapse of vapor bubbles create intense shear and
          turbulence, ideal for processing concentrated and viscous materials.
        </motion.p>

        {/* 2-Column Grid for the 6 Key Benefits */}
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Key Benefits</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
          {keyBenefits.map((point, index) => (
            <motion.div
              key={point.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 flex items-start space-x-4 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-pink-100 rounded-full text-pink-600">
                {point.icon}
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{point.title}</h3>
                <p className="text-gray-700">{point.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Applications Section */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-lg shadow-xl p-8"
        >
          <h2 className="text-3xl font-bold text-center mb-4">Applications</h2>
          <p className="text-lg text-center text-blue-100 max-w-3xl mx-auto">
            Used across rubber and polymer processing, paints, coatings,
            emulsions, food, and pharmaceuticals, cavitation delivers superior mixing,
            enhanced product stability, and sustainable process performance.
          </p>
        </motion.div>

      </div>
    </div>

    <WhatsAppConnect />
  </div>
);

export default EmulsionStability;